<h3 mat-dialog-content>Zmień klienta</h3>
<mat-dialog-content>
	<mat-radio-group class="d-flex flex-row gap-2 mt-3" [(ngModel)]="selectedCustomerType">
		<mat-radio-button (change)="changeSelectedData(true)" [value]="customerType.PRIVATE"
			>Klient indywidualny
		</mat-radio-button>
		<mat-radio-button (change)="changeSelectedData(false)" [value]="customerType.COMPANY">Firma </mat-radio-button>
	</mat-radio-group>
	<div class="row w-50 mx-auto mt-3">
		<ng-container *ngIf="selectedCustomerType === customerType.PRIVATE">
			<mat-form-field appearance="outline">
				<mat-label>Wyszukaj</mat-label>
				<input type="text" matInput [matAutocomplete]="autoUser" [formControl]="usersSelect" />
				<mat-autocomplete
					#autoUser="matAutocomplete"
					[displayWith]="displayUsersFn.bind(this)"
					(optionSelected)="selectUser($event)"
				>
					<mat-option *ngFor="let user of filteredUsers" [value]="user">
						{{ user.firstName }} {{ user.lastName
						}}<span *ngIf="user.birth"> | {{ user.birth | date: 'dd.MM.yyyy' }}</span
						><span *ngIf="user.userContacts[0]"> | {{ user.userContacts[0].phone }}</span>
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</ng-container>
		<ng-container *ngIf="selectedCustomerType === customerType.COMPANY">
			<mat-form-field appearance="outline">
				<mat-label>Wyszukaj firmy</mat-label>
				<input type="text" matInput [matAutocomplete]="auto" [formControl]="organizationSelect" />
				<mat-hint *ngIf="selectedCustomerType === customerType.COMPANY" align="end"> Wpisz nazwe </mat-hint>
				<mat-autocomplete
					#auto="matAutocomplete"
					[displayWith]="displayFn.bind(this)"
					(optionSelected)="selectOrganization($event)"
				>
					<ng-container>
						<mat-option *ngFor="let organization of filteredOrganizations" [value]="organization">
							{{ organization.name }}
						</mat-option>
					</ng-container>
				</mat-autocomplete>
			</mat-form-field>
		</ng-container>
		<div mat-dialog-actions>
			<button
				mat-raised-button
				color="primary"
				[disabled]="
					selectedCustomerType === customerType.PRIVATE
						? selectedUser === null
						: data.ownerOrganization === null
				"
				(click)="submit()"
			>
				Zmień
			</button>
			<ng-container *ngIf="selectedCustomerType === customerType.COMPANY">
				<button mat-raised-button color="warn" (click)="dataDownload()">Pobierz dane z krs</button>
			</ng-container>
			<ng-container *ngIf="selectedCustomerType === customerType.PRIVATE">
				<button mat-raised-button color="warn" (click)="addUserData()">Dodaj klienta</button>
			</ng-container>
		</div>
	</div>
</mat-dialog-content>
